import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";
import { useDenominationStore } from "../store";

export const updateDenomination = ({ denominationData, denominationId }) => {
  return axios.post(
    `/denominations/${denominationId}?_method=PATCH`,
    denominationData
  );
};

export const useUpdateDenomination = ({ config, redirect = true } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;
  const selectDenomination = useDenominationStore.getState().selectDenomination;

  return useMutation({
    onSuccess: data => {
      queryClient.invalidateQueries(["denomination"]);
      queryClient.invalidateQueries(["denomination-children"]);
      queryClient.invalidateQueries(["denominations-hierarchy"]);

      setNotification({
        type: "success",
        message: "Denomination updated successfully!"
      });

      if (redirect) {
        selectDenomination(data.result);
      }
    },
    ...config,
    mutationFn: updateDenomination
  });
};
